import { Badge, BadgeSize } from "shared/components";
import { mapIncomeSourceStatus } from "../helpers";
import { CombinedIncome } from "../types/income";
import { INCOME_SOURCE_BADGE_STATUSES_MAP } from "../constants";
import { VerifiedBankStatement } from "../types/verified/bank-statment";

export const IncomeSourceStatusBadge = ({
  income,
  forceInProgress = false,
  bankStatements
}: {
  income: CombinedIncome;
  forceInProgress?: boolean;
  bankStatements?: Record<number, VerifiedBankStatement>;
}) => {
  const { status } = mapIncomeSourceStatus(income, bankStatements);

  const effectiveStatus = forceInProgress ? "Started" : status || "Accepted";
  const config = INCOME_SOURCE_BADGE_STATUSES_MAP[effectiveStatus];

  if (config)
    return (
      <Badge
        variant={config.variant}
        size={BadgeSize.SM}
        borderless={false}
        className="items-center"
        tooltip={config.tooltip}
      >
        {effectiveStatus === "Rejected" ? "Unverified" : config.title}
      </Badge>
    );

  return null;
};
